import { ActionContext } from 'vuex';

import { State } from '@/models/main';

export interface ModuleScheduler {
  travelTimes: TravelTime;
}

export interface TravelTime {
  ['string']: string;
}

export const moduleScheduler = {
  namespaced: true,
  state: {
    travelTimes: {},
  },
  getters: {
    travelTimes: (state: ModuleScheduler): TravelTime => {
      return state.travelTimes;
    },
  },
  actions: {
    async setTravelTime(
      { commit }: ActionContext<ModuleScheduler, State>,
      travelTime: TravelTime,
    ): Promise<void> {
      commit('SET_TRAVEL_TIME', travelTime);
    },
  },
  mutations: {
    SET_TRAVEL_TIME(state: ModuleScheduler, travelTime: TravelTime): void {
      state.travelTimes = { ...state.travelTimes, ...travelTime };
    },
  },
};
